import axios from "./axios";
import { ApiResponse } from "../types/express-data.type";
import {
  ExpressAccount,
  ExpressAccountRequest,
  ExpressContact,
  ExpressContactListParams,
  ExpressContactRequest,
  ExpressMasterList,
  ExpressMasterListParams,
} from "../types/express-master.type";

const EXPRESS_CONTACTS_PATH = "/express-contacts";
const EXPRESS_ACCOUNTS_PATH = "/express-accounts";

/**
 * A refusal on a write (a code already used) is the server's message in the global toast; the
 * dialog stays open, so the 403 redirect is off.
 */
const WRITE_META = { suppressForbiddenRedirect: true };

const masterPath = (basePath: string, uuid: string) => `${basePath}/${encodeURIComponent(uuid)}`;

export const getExpressContacts = (params: ExpressContactListParams) =>
  axios.get<ApiResponse<ExpressMasterList<ExpressContact>>>(EXPRESS_CONTACTS_PATH, { params });

export const createExpressContact = (body: ExpressContactRequest) =>
  axios.post<ApiResponse<ExpressContact>>(EXPRESS_CONTACTS_PATH, body, {
    meta: { ...WRITE_META, successMsg: "เพิ่มผู้จำหน่าย / ลูกค้าสำเร็จ" },
  });

export const updateExpressContact = (uuid: string, body: ExpressContactRequest) =>
  axios.put<ApiResponse<ExpressContact>>(masterPath(EXPRESS_CONTACTS_PATH, uuid), body, {
    meta: { ...WRITE_META, successMsg: "บันทึกผู้จำหน่าย / ลูกค้าสำเร็จ" },
  });

export const getExpressAccounts = (params: ExpressMasterListParams) =>
  axios.get<ApiResponse<ExpressMasterList<ExpressAccount>>>(EXPRESS_ACCOUNTS_PATH, { params });

export const createExpressAccount = (body: ExpressAccountRequest) =>
  axios.post<ApiResponse<ExpressAccount>>(EXPRESS_ACCOUNTS_PATH, body, {
    meta: { ...WRITE_META, successMsg: "เพิ่มรหัสบัญชีสำเร็จ" },
  });

export const updateExpressAccount = (uuid: string, body: ExpressAccountRequest) =>
  axios.put<ApiResponse<ExpressAccount>>(masterPath(EXPRESS_ACCOUNTS_PATH, uuid), body, {
    meta: { ...WRITE_META, successMsg: "บันทึกรหัสบัญชีสำเร็จ" },
  });
